// src/pages/processifyd/ProcessifydStates.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faFolderOpen,
  faSearch,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faList,
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydStates = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [states, setStates] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const [showModal, setShowModal] = useState(false);
  const [editingState, setEditingState] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [loading, setLoading] = useState(false);
  
  const initialForm = {
    stateName: "",
    aboutTheState: "",
    stateType: "",
    processName: "",           // Reference to Process (like CSAT Program Management Process)
    clientName: "",
    active: "Yes",
  };

  const [formData, setFormData] = useState(initialForm);

  // Sample Demo Data
  const demoStates = [
    {
      id: 1,
      stateName: "New Survey Created",
      aboutTheState: "A new CSAT survey has been created and is ready for distribution.",
      stateType: "Start",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:00",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:00",
    },
    {
      id: 2,
      stateName: "Survey Distribution Initiated",
      aboutTheState: "Survey distribution process has been initiated.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:01",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:01",
    },
    {
      id: 3,
      stateName: "Survey Distribution in Progress",
      aboutTheState: "Survey is actively being distributed to customers.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:02",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:02",
    },
    {
      id: 4,
      stateName: "Survey Distribution Finished",
      aboutTheState: "Survey distribution has been completed.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:03",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:03",
    },
    {
      id: 5,
      stateName: "Survey Abandoned",
      aboutTheState: "Survey process was discontinued before completion.",
      stateType: "Terminal",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:04",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:04",
    },
    {
      id: 6,
      stateName: "Feedback Collection in Progress",
      aboutTheState: "Customer feedback is being collected.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:05",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:05",
    },
    {
      id: 7,
      stateName: "New Feedback Received",
      aboutTheState: "Customer has submitted feedback response.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:06",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:06",
    },
    {
      id: 8,
      stateName: "Response Followup Preparation Initiated",
      aboutTheState: "Preparation for follow-up response has started.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:07",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:07",
    },
    {
      id: 9,
      stateName: "Feedback Validated",
      aboutTheState: "Received feedback has been verified and validated.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:08",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:08",
    },
    {
      id: 10,
      stateName: "Response Followup Communication in Progress",
      aboutTheState: "Follow-up communication with customer is ongoing.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:09",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:09",
    },
    {
      id: 11,
      stateName: "Response Followup Communication Finished",
      aboutTheState: "Follow-up communication has been completed.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:10",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:10",
    },
    {
      id: 12,
      stateName: "Feedback Collection Finished",
      aboutTheState: "All feedback responses have been collected.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:11",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:11",
    },
    {
      id: 13,
      stateName: "Feedback Analysis Initiated",
      aboutTheState: "Analysis of collected feedback has started.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:12",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:12",
    },
    {
      id: 14,
      stateName: "CSAT Report Initiated",
      aboutTheState: "Preparation of CSAT report has started.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:13",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:13",
    },
    {
      id: 15,
      stateName: "Feedback Analysis in Progress",
      aboutTheState: "Feedback data is currently being analyzed.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:14",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:14",
    },
    {
      id: 16,
      stateName: "Feedback Analysis Done",
      aboutTheState: "Feedback analysis has been completed.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:15",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:15",
    },
    {
      id: 17,
      stateName: "Rating Aggregation Initiated",
      aboutTheState: "Aggregation of ratings has started.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:16",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:16",
    },
    {
      id: 18,
      stateName: "Rating Aggregation / Scorecard Initiated",
      aboutTheState: "Scorecard generation process has been initiated.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:17",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:17",
    },
    {
      id: 19,
      stateName: "Rating Aggregation / Scorecard in Progress",
      aboutTheState: "Scorecard is being generated and aggregated.",
      stateType: "Intermediate",
      processName: "CSAT Program Management Process",
      active: "Yes",
      clientName: "21st Century Financial Services",      
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 12:18",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 12:18",
    },
  ];

  const loadSample = () => {
    setStates(demoStates);
  };

  const handleAddNew = () => {
    setEditingState(null);
    setFormData(initialForm);
    setShowModal(true);
  };

  const handleEdit = (st) => {
    setEditingState(st);
    setFormData({
      stateName: st.stateName,
      aboutTheState: st.aboutTheState || "",
      stateType: st.stateType || "",
      processName: st.processName || "",
      active: st.active || "Yes",
      clientName: st.clientName || "",
    });
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this state? This action cannot be undone.")) return;
    setStates((prev) => prev.filter((s) => s.id !== id));
  };

  const handleOpenState = (st) => {
    // Update route as per your actual state detail page
    navigate(`/processifyd-statehub/${st.id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.stateName.trim() || !formData.processName.trim()) {
      alert("State Name and Process Name are required.");
      return;
    }

    const newState = {
      id: editingState?.id || Date.now(),
      ...formData,
      createdBy: editingState?.createdBy || "Sanjeev Kumar",
      createdDate: editingState?.createdDate || new Date().toLocaleString("en-IN"),
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: new Date().toLocaleString("en-IN"),
    };

    if (editingState) {
      setStates((prev) =>
        prev.map((s) => (s.id === editingState.id ? newState : s))
      );
    } else {
      setStates((prev) => [...prev, newState]);
    }

    setShowModal(false);
    setFormData(initialForm);
  };

  // Filter + Pagination
  const filtered = states.filter(
    (s) =>
      s.stateName.toLowerCase().includes(search.toLowerCase()) ||
      s.processName.toLowerCase().includes(search.toLowerCase()) ||
      s.clientName.toLowerCase().includes(search.toLowerCase()) ||
      s.aboutTheState.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const [showList, setShowList] = useState(false);
  
  const handleShowMyStates = async () => {
    try {
      setLoading(true);

      // 🔄 Replace this later with API call
      // const response = await axios.get("/api/states");
      // setStates(response.data);

      // ✅ Temporary Demo Data (remove later)
      setStates([]);

      setShowList(true);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            🔄 Processifyd
          </div>
          <div className="text-xs text-gray-400">
            State Master Management
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 hover:bg-teal-900/30 rounded-md"
            >
              🔐
            </button>
          )}
        </div>

        <button
          className="md:hidden text-2xl text-cyan-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-4">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-4">
              <div className="text-teal-300">{userName}</div>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700 rounded-md">⏻</button>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh]">
        {/* Controls */}
        <div className="mt-4 flex flex-col lg:flex-row gap-4">
          <div className="flex flex-row gap-3">
            <button
              onClick={loadSample}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Load Sample States
            </button>
            <button
              onClick={handleShowMyStates}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faList} />
              My States List
            </button>
            <button
              onClick={handleAddNew}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              New State
            </button>
          </div>

          <div className="relative w-full">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              type="text"
              placeholder="Search by state name, process or description..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500/60"
            />
          </div>
        </div>

        {/* State Cards */}
        <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-3 xl:grid-cols-4">
          {paginated.map((st) => (
            <div
              key={st.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-cyan-600/50 transition-colors group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors line-clamp-2">
                    {st.stateName}
                  </h3>
                  <div className="text-sm text-gray-400 mt-1">
                    {st.stateType} • In: <span className="text-cyan-300">{st.processName}</span>
                  </div>
                  <div className="text-sm text-gray-400 mt-1">
                    {st.clientName}
                  </div>
                </div>

                <div className="flex flex-col items-end gap-1">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${st.active === "Yes" ? "bg-emerald-600" : "bg-red-600"}`}>
                    {st.active === "Yes" ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>

              <p className="mt-4 text-sm text-gray-300 line-clamp-3">
                {st.aboutTheState || "No description available"}
              </p>

              <div className="mt-6 flex gap-2">
                <button
                  onClick={() => handleOpenState(st)}
                  className="flex-1 py-2 w-32 bg-gradient-to-r from-cyan-700 to-teal-700 hover:from-cyan-600 hover:to-teal-600 rounded-lg font-medium flex items-center justify-center gap-2 text-sm"
                >
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Open
                </button>

                <button
                  onClick={() => handleEdit(st)}
                  className="p-2 w-12 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Edit State"
                >
                  <FontAwesomeIcon icon={faEdit} className="text-yellow-400" />
                </button>

                <button
                  onClick={() => handleDelete(st.id)}
                  className="p-2 w-12 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Delete State"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-400" />
                </button>
              </div>
            </div>
          ))}

          {paginated.length === 0 && (
            <div className="col-span-full py-12 text-center text-gray-500">
              {search ? "No states match your search" : "No states yet. Click 'New State' or 'Load Sample States'"}
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="w-12 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="text-sm">
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="w-12 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )}

        {showList && (
          <div className="mt-4 bg-black text-white rounded-lg p-4">
            {loading ? (
              <p className="text-yellow-200">Loading states...</p>
            ) : states.length === 0 ? (
              <p className="text-yellow-200">No states found.</p>
            ) : (
              <ul className="space-y-2">
                {states.map((st) => (
                  <li
                    key={st.id}
                    className="border border-gray-700 rounded p-2"
                  >
                    <p className="font-semibold text-gray-100">{st.stateName}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Add / Edit Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-6 w-full max-w-2xl border border-gray-700 max-h-[92vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                  {editingState ? "Edit State" : "New State"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-white w-12 text-2xl"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5">State Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.stateName}
                    onChange={(e) => setFormData({ ...formData, stateName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. Survey Archival Finished"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">About the State</label>
                  <textarea
                    value={formData.aboutTheState}
                    onChange={(e) => setFormData({ ...formData, aboutTheState: e.target.value })}
                    rows={4}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="Description of this state..."
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">State Type</label>
                    <input
                      value={formData.stateType}
                      onChange={(e) => setFormData({ ...formData, stateType: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. Terminal, Intermediate, Start"
                    />
                  </div>

                  <div>
                    <label className="block text-sm mb-1.5">Process Name <span className="text-red-400">*</span></label>
                    <input
                      required
                      value={formData.processName}
                      onChange={(e) => setFormData({ ...formData, processName: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. CSAT Program Management Process"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm mb-1.5">Client <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.clientName}
                    onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. 21st Century Financial Services"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Active <span className="text-red-400">*</span></label>
                    <select
                      value={formData.active}
                      onChange={(e) => setFormData({ ...formData, active: e.target.value })}
                      className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
                  >
                    {editingState ? "Update State" : "Create State"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-8">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydStates;